import { useSelector } from 'react-redux';
import { RootState } from '@/models/RootState.type';
import { UsageWindow } from '@/models/UsageWindow.interface';
import useRosterInfo from './useRosterInfo';

export const useTeacherSelections = () => {
  const { students, classroomId, schoolId, districtId } = useRosterInfo();
  const usageWindow = useSelector<RootState, UsageWindow>(state => state.reports.teacher.usageWindow);
  const tutorTime = useSelector<RootState, {value: string, label: string}>(state => state.reports.teacher.tutorTime);
  const badgingLocale = useSelector<RootState, {english?: boolean, spanish?: boolean}>(state => state.reports.teacher.badgingLocale);

  return {
    students,
    classroomId,
    schoolId,
    districtId,
    usageWindow,
    usageWindowType: usageWindow.value,
    tutorTime,
    badgingLocale,
    badgingLocaleEnglish: badgingLocale.english,
    badgingLocaleSpanish: badgingLocale.spanish
  };
};

export default useTeacherSelections; 